export class SetPlaceholder {
    public static readonly type = '[Messaging] set placeholder';

    constructor(public message: string) {}
}
